import React, { Component } from 'react'
import Breadcrumbs from '../../components/Common/Breadcrumb'
import { Container, Row, Col, Button, Card, CardBody, CardTitle, CardSubtitle, Modal, ModalHeader, ModalBody, ModalFooter, Media, Table } from "reactstrap";

import Notiflix from "notiflix";

import PostApiCall from '../../Api'
import GetApiCall from '../../GETAPI'
import moment from 'moment';

import { MDBDataTableV5, MDBCol, MDBTableBody, MDBTableHead } from 'mdbreact';


class Chits extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accountNo: '',
      ChitSchema: [],
      dropdownArray: [],
      searchInput:'',
      InstallmentData:[],
      USERDATA:[]
    };
  }

  componentDidMount = () => {

    Notiflix.Loading.Init({
      svgColor: '#880105'

    });

    // Notiflix.Loading.Dots('Please wait...');
    var det = localStorage.getItem('LoginDetail')
    var detail = JSON.parse(det)
    console.log(detail[0])

    // PostApiCall.postRequest(
    //   {
    //     id: detail[0].fld_id
    //   },
    //   "Get_Client_ChitScheme"
    // ).then((results) =>
    //   results.json().then((obj) => {
    //     if (results.status == 200 || results.status == 201) {
    //       this.setState({
    //         ChitSchema: obj.data,

    //       })
    //       Notiflix.Loading.Remove();


    //     }
    //   }))

    //   PostApiCall.postRequest(
    //     {
    //       chitid: detail[0].fld_id
    //     },
    //     "Get_TransactionData"
    //   ).then((results2) =>
    //     results2.json().then((obj2) => {
    //       if (results2.status == 200 || results2.status == 201) {
    //         console.log(obj2.data)
    //          this.setState({
    //            InstallmentData:obj2.data
    //          })

    //       }}
    //     ))
        
    Notiflix.Loading.Dots('Please wait...');
         GetApiCall.getRequest("Get_customerList").then(resultdes =>
      resultdes.json().then(obj => {
        console.log(obj.data)

       
       
          this.setState({
              USERDATA:obj.data
      })

      Notiflix.Loading.Remove();
    }
      ))


    // GetApiCall.getRequest("Get_New_Client_chitSchema").then(resultdes =>
    //   resultdes.json().then(obj => {
    //     // console.log(obj.data)
    //       this.setState({
    //           ChitSchema:obj.data
    //   })
    //   Notiflix.Loading.Remove();
    // })).then(res=>{
    //   let tempArray=[]
    //   this.state.ChitSchema.map(data=>{
    //     tempArray.push({value:data.fld_accountno,label:data.fld_accountno})
    //   })
    //  this.setState({dropdownArray:tempArray})

    // })


    // GetApiCall.getRequest("Get_New_ClientChitSchemaData").then(resultdes =>
    //   resultdes.json().then(obj => {
    //     // console.log(obj.data)
    //       this.setState({
    //           allDetails:obj.data
    //   })
    //   Notiflix.Loading.Remove();
    // }))


  }

  // viewdetail(data) {

  //   localStorage.setItem('ChitDetails', JSON.stringify(data))
  //   this.props.history.push(`/viewchitdetails/${
  //     data.id}`)
  // }


  seachBarHandler = (e) => {
    this.setState({ ...this.state, searchInput: e.target.value })
}

generatePassword(){
    var det = localStorage.getItem('LoginDetail')
    var detail = JSON.parse(det)

    // console.log(this.state.Email)

    Notiflix.Loading.Dots('Please wait...');
   

for(var i=0;i<this.state.USERDATA.length;i++){
    // console.log(this.state.USERDATA[i].fld_old_password)
  
    PostApiCall.postRequest({
        id:this.state.USERDATA[i].fld_id,
        name :this.state.USERDATA[i].fld_name,
           email :this.state.USERDATA[i].fld_email,
           mobile :this.state.USERDATA[i].fld_mobile,
           usertype :'Customer',
           password :this.state.USERDATA[i].fld_old_password,
            updatedon: moment().format('lll'),
            updatedby: detail[0].fld_userid,
   
   }, "Update_Customer_Password").then((result) =>

       result.json().then(obj => {
           if (result.status == 200 || result.status == 201) {

               // console.log(obj)
               Notiflix.Loading.Remove();
               Notiflix.Notify.Success('User Successfully added.')
               window.location.reload()
            //    this.onPostApprove(obj)

           } else {
               Notiflix.Loading.Remove()
               Notiflix.Notify.Failure(obj.data)
               // console.log(obj.data)
           }
       })
   )
}
}




  render() {

    // console.log(this.state.ChitSchema);
    // let rowData = this.state.ChitSchema.map(info => {
    //   return {
    //     name: info.fld_name,
    //     accountNo: info.fld_accountno,
    //     chit_scheme: info.fld_chitschema,
    //     duration: info.fld_duration,
    //     amount: info.fld_chitamount,
    //     id: info.fld_id
    //   }
    // })


    const data = {
      columns: [
        {
          label: "S.No",
          field: "s_no",
          sort: "disabled",
          width: 150
        },
        {
          label: "Account No",
          field: "accountNo",
          sort: "disabled",
          width: 100
        },
        {
          label: "Chit Scheme",
          field: "chit_scheme",
          sort: "disabled",
          width: 150
        },
     
        {
          label: "Installement Number",
          field: "number",
          sort: "disabled",
          width: 150
        },
        {
          label: "Installement Amount",
          field: "amount",
          sort: "disabled",
          width: 150
        },


      ],
      rows: this.state.InstallmentData.filter(data => {
        if (this.state.searchInput == '') {
          return data
        }
        // else if (data.accountno == this.state.accountno) {
        //   return data
        // }
      }).map((data, i) => {
        return {
        s_no: <td>{(i+1)}</td>,
          accountNo: <td>{data.accountno}</td>,
        chit_scheme: <td>{data.fld_chitschema}</td>,
        amount: <td>{data.paidamount}</td>,
          number:<td>{data.fld_installment_id}</td>

        }
      })

    };

  
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>

            {/* Render Breadcrumb */}
            <Breadcrumbs title={'Chits'} breadcrumbItem={'Chits List'} />
            <Row>
              <Col xl="12">

                <Card className="overflow-hidden">
                  <div className="maxXchange-bg-soft-pink" style={{ background: 'rgb(171, 61, 0)' }}>
                    <Row>


                      <Col xs="6">
                        <div className="maxXchange-text p-3"><h5 className="maxXchange-text">Jewel Scheme Payment</h5>

                        </div>
                      </Col>


                    </Row>
                    <Row>

                    </Row>
                  </div>

                  <Card className="overflow-hidden">
                    <div className="maxXchange-bg-soft-pink" style={{ background: '#dfb65c' }}>
                      <Row>


                        <Col xs="6">
                          <div className="maxXchange-text p-3">
                            <h5 className="maxXchange-text">Jewel Scheme Payment List</h5>

                          </div>
                        </Col>

                        <Col xs="6">
                          <div className="maxXchange-text p-3">
                           <a onClick={this.generatePassword.bind(this)}>
                               generatePassword
                           </a>
                          </div>
                        </Col>


                      </Row>
                    </div>
                    <CardBody className="pt-0">
                      <Row>
                        <MDBCol md="3" style={{ marginBottom: '10px', marginTop: '10px' }}>
                          <input className="form-control" type="text" placeholder="Search" aria-label="Search" onChange={(e) => this.seachBarHandler(e)} value={this.state.searchInput} />
                        </MDBCol>
                        <Col md="12">

                          <MDBDataTableV5

                            striped
                            bordered
                            small
                            data={data}
                            searchBottom={false}
                            seachTop={true}
                          >

                            <MDBTableHead columns={data.columns} />
                            <MDBTableBody rows={data.rows} />
                          </MDBDataTableV5>

                        </Col>

                      </Row>
                    </CardBody>
                  </Card>


                  {/* <WelcomeComp /> */}


                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}
export default Chits